<template>
  <div class="manualPage">
    <iframe :src="fileInfo.filePath" style="width: 100%;height: 100%; border: 0;" v-if="fileInfo" />
    <!-- <filePreview :fileOption="fileInfo" style="width: 100%" v-if="fileInfo"></filePreview> -->
  </div>
</template>
<script>
export default {
  name: 'manual',
  data () {
    return {
      showSpan: false,
      fileInfo: null
    }
  },
  methods: {
    getFile: function () {
      let that = this
      this.$axios.post(that.$apis.manualApi.getFile).then(res => {
        if (res.success) {
          that.fileInfo = res.result || {}
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取文件失败！")
      })
    },
  },
  beforeMount () {
    this.getFile()
  }
}
</script>
<style lang="less" scoped>
.manualPage {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>